import { listOfCustomer } from "Api/customer";
import { deleteStaffApi, listOfStaff, updateStatusStaff } from "Api/staff";
import BaseButton from "Components/Base/BaseButton";
import Loader from "Components/Base/BaseLoader";
import TableContainer from "Components/Base/BaseTable";
import DeleteModal from "Components/Base/DeleteModal";
import {
  checkStatusCodeSuccess,
  closeLabel,
  notFound,
  Search,
} from "Components/constants/Common";
import {
  ActionKey,
  ActionLabel,
  DeleteLabel,
  editLabel,
  NameKey,
  NewLabel,
  NoLabel,
  StatusUpdateLabel,
  StatusUpdateMessageLabel,
  submitLabel,
  YesLabel,
} from "Components/constants/Role";
import {
  ContactNoKey,
  CustomerIdLabel,
  CustomerLabel,
  CustomerNameLabel,
  CustomerTypeKey,
  CustomerTypeLabel,
  EmailKey,
  EmailLabel,
  PhoneNumberLabel,
  userDraftIdLabel,
} from "Components/constants/Staff";
import { SetStateAction, useEffect, useMemo, useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const Customer = () => {
  document.title = CustomerLabel;
  const navigate = useNavigate();
  const [customerData, setCustomerData] = useState<Array<any>>([]);
  const [customerSearchData, setCustomerSearchData] = useState<Array<any>>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [tableLoader, setTableLoader] = useState<boolean>(false);
  const [btnLoader, setBtnLoader] = useState<boolean>(false);
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [isActiveModal, setIsActiveModal] = useState<boolean>(false);
  const [isActiveModalState, setIsActiveModalState] = useState<string>("");
  const [activeModalId, setActiveModalId] = useState<number>();
  const [deleteId, setDeleteId] = useState<number>();
  const [totalNumberOfRows, setTotalNumberOfRows] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [columnName, setColumnName] = useState("id");
  const [sortOrder, setSortOrder] = useState("desc");
  const [currentPage, setCurrentPage] = useState(1);
  const [customPageSize, setCustomPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");

  const handleFetchSorting = (
    page: any,
    id: SetStateAction<string>,
    order: SetStateAction<string>
  ) => {
    setCurrentPage(page);
    setColumnName(id);
    setSortOrder(order);
  };
  const handleFetchData = (page: any) => {
    setCurrentPage(page);
  };
  const handleDelete = (id: string) => {
    setDeleteOpen(!deleteOpen);
    setDeleteId(Number(id));
  };
  const handleActive = (id: string, state: string) => {
    setIsActiveModal(!isActiveModal);
    setActiveModalId(Number(id));
    setIsActiveModalState(state);
  };

  const handleSearchValueChange = (value: any) => {
    if (value !== searchValue) {
      setCurrentPage(1);
      setSearchValue(value);
    }
  };

  const customerColumns = useMemo(
    () => [
      {
        header: CustomerIdLabel,
        accessorKey: userDraftIdLabel,
        cell: (cell: any) => cell.getValue(),
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: CustomerTypeLabel,
        accessorKey: CustomerTypeKey,
        enableSorting: true,
        enableColumnFilter: false,
      },
      {
        header: CustomerNameLabel,
        accessorKey: NameKey,
        enableColumnFilter: false,
      },
      {
        header: PhoneNumberLabel,
        accessorKey: ContactNoKey,
        enableColumnFilter: false,
      },
      {
        header: EmailLabel,
        accessorKey: EmailKey,
        enableColumnFilter: false,
      },
      {
        header: ActionLabel,
        accessorKey: ActionKey,
        cell: (cell: any) => (
          <div className="d-flex justify-content-start enable-action flex-wrap gap-2 icon">
            <span className="tooltip-container">
              <i
                className={`mdi mdi-pencil-outline fs-4 text-info cursor-pointer`}
                onClick={() =>
                  navigate(`/editcustomer/${cell?.row?.original?.id}`)
                }
              ></i>
              <span className="tooltip-text">{editLabel}</span>
            </span>

            {/* delete future purpose */}
            {/* <span className="tooltip-container">
              <i
                className="mdi mdi-delete-outline fs-4 text-danger cursor-pointer"
                onClick={() => handleDelete(cell?.row?.original?.id)}
              ></i>
              <span className="tooltip-text">{DeleteLabel}</span>
            </span> */}
          </div>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
    ],
    []
  );

  const handleStatusChange = () => {
    setBtnLoader(true);
    const payload = {
      status: !isActiveModalState,
    };
    updateStatusStaff(Number(activeModalId), payload)
      .then((resp) => {
        if (checkStatusCodeSuccess(resp?.statusCode)) {
          toast.success(resp?.message);
        } else {
          toast.error(resp?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || error?.message);
      })
      .finally(() => {
        setBtnLoader(false);
        setIsActiveModal(!isActiveModal);
        fetchCustomerData();
      });
  };

  const deletePosition = () => {
    setBtnLoader(true);
    deleteStaffApi(Number(deleteId))
      .then((resp) => {
        if (checkStatusCodeSuccess(resp?.statusCode)) {
          toast.success(resp?.message);
        } else {
          toast.error(resp?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || error?.message);
      })
      .finally(() => {
        setBtnLoader(false);
        setDeleteOpen(!deleteOpen);
        fetchCustomerData();
      });
  };

  const fetchCustomerData = () => {
    setLoader(true);
    const payload = {
      sortKey: columnName,
      sortValue: sortOrder,
      page: currentPage,
      type_of_user: CustomerLabel,
      limit: customPageSize,
    };
    listOfCustomer(payload)
      .then((response) => {
        if (checkStatusCodeSuccess(response.statusCode)) {
          setCustomerData(response.data.positions);
          setTotalRecords(response.data.totalItems);
          setTotalPages(response?.data?.totalPages);
          setTotalNumberOfRows(response?.data?.numberOfRows);
          if (searchValue) {
            fetchSearchCustomerData();
          }
        }
      })
      .catch((error) => {
        setCustomerData([]);
        return error;
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const fetchSearchCustomerData = () => {
    setLoader(true);
    const payload = {
      sortKey: columnName,
      sortValue: sortOrder,
      page: currentPage,
      type_of_user: CustomerLabel,
      search: searchValue,
      limit: customPageSize,
    };
    listOfStaff(payload)
      .then((response) => {
        if (checkStatusCodeSuccess(response.statusCode)) {
          setCustomerSearchData(response.data.positions);
          setTotalRecords(response.data.totalItems);
          setTotalPages(response?.data?.totalPages);
          setTotalNumberOfRows(response?.data?.numberOfRows);
        }
      })
      .catch((error) => {
        setCustomerSearchData([]);
        return error;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    if (searchValue === "") {
      setCurrentPage(1);
    }
  }, [searchValue]);

  useEffect(() => {
    if (searchValue) {
      fetchSearchCustomerData();
    } else {
      fetchCustomerData();
    }
  }, [currentPage, customPageSize, sortOrder, columnName, searchValue]);

  return (
    <div className="page-content">
      <div className="flex-grow-1 mx-3">
        <div className="mb-1 mx-2 d-flex justify-content-between align-items-center">
          <span className="fs-4 d-flex gap-4">{CustomerLabel}</span>
          <div className="d-flex align-items-center gap-2">
            <BaseButton
              className="btn btn-success"
              onClick={() => navigate("/addcustomer")}
              children={
                <>
                  <i className="mdi mdi-plus" /> {NewLabel}
                </>
              }
            />
          </div>
        </div>
        <div className="card py-2 px-4 overflow-x-auto">
          {loader || customerData.length > 0 ? (
            <TableContainer
              customPageSize={customPageSize}
              setCustomPageSize={setCustomPageSize}
              isGlobalFilter={true}
              columns={customerColumns}
              data={searchValue ? customerSearchData : customerData || []}
              tableClass="table bg-white"
              manualPagination={true}
              manualFiltering={true}
              tableLoader={loader}
              hasManualPagination={true}
              SearchPlaceholder={Search}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
              totalRecords={totalRecords}
              onSearch={handleSearchValueChange}
              totalNumberOfRows={totalNumberOfRows}
              fetchData={handleFetchData}
              fetchSortingData={handleFetchSorting}
            />
          ) : (
            <div className="py-4 text-center">
              <div>
                <span className="fs-1 text-success">
                  <RiSearchLine />
                </span>
              </div>
              <div className="mt-4">
                <h5>{notFound.dataNotFound}</h5>
                <p className="text-muted">{notFound.thereIsNoDataFound}</p>
              </div>
            </div>
          )}
        </div>
        <DeleteModal
          btnLoader={Boolean(btnLoader)}
          onCloseClick={() => setDeleteOpen(!deleteOpen)}
          onDeleteClick={() => deletePosition()}
          show={deleteOpen}
        />
        <Modal
          isOpen={isActiveModal}
          toggle={() => setIsActiveModal(!isActiveModal)}
          centered
        >
          <ModalHeader
            toggle={() => setIsActiveModal(!isActiveModal)}
            className="border-bottom pb-2"
          >
            {StatusUpdateLabel}
          </ModalHeader>
          <ModalBody>{StatusUpdateMessageLabel}</ModalBody>
          <ModalFooter>
            <BaseButton
              color="success"
              children={submitLabel}
              loader={btnLoader}
              disable={btnLoader}
              onClick={() => handleStatusChange()}
            />
            <BaseButton
              color="danger"
              children={closeLabel}
              onClick={() => setIsActiveModal(!isActiveModal)}
            />
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

export default Customer;
